// extracted by mini-css-extract-plugin
module.exports = {"rejectedReason":"DocumentsList-module__rejectedReason--mQvcm"};